import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { fetchCustomers, fetchActiveCustomers } from '../../actions/customers_actions';
import { fetchCustomersWithFavorites } from '../../actions/favoriteList_actions';
import { fetchSalesOrderInventory } from '../../actions/inventories_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { fetchFavorites, fetchFavoriteList } from '../../actions/favorites_actions';
import {
  fetchPreviousOrders,
  fetchPreviousSalesOrderByIndexFromLast,
  fetchPreviousSalesOrderByCustomer,
  fetchPreviousOrderById,
  fetchPreviousOrdersFromALLSalesOrder,
  fetchPreviousOrderBySearch,
} from '../../actions/previousOrders_actions';
import { fetchPromotions } from '../../actions/promotions_actions';
import { fetchBaseUsers, checkPermission } from '../../actions/settings_actions';
import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { setDefaultSearchType } from '../../actions/purchaseOrders_actions';
import { fetchProductInfo, fetchProductInfo2 } from '../../actions/products_actions';
import { clearConvertingToInvoice } from '../../actions/dispatch_actions';
import { clearUpdateSalesInvoice } from '../../actions/salesInvoice_actions';
import { fetchVendors } from '../../actions/vendors_actions';
import SalesOrderForm from '../../components/Sales/salesOrderForm';
import {
  createSalesOrder,
  editSalesOrder,
  keepEstDate,
  destroyEstDate,
  fetchSalesOrderDetail,
  fetchSalesOrderForm,
  clearInventories,
  fetchCustomerPrices,
  fetchTaxRates,
  setSaleRowValue,
  fetchSalesCustomerDetail,
  setCredit,
  setSubtotal,
  resetFormInputs,
  fetchItemSalesHistory,
  fetchCustomerSalesHistory,
  fetchCustomerFrequent,
  fetchInboundProducts,
  clearSalesCustomerDetails,
  selectSalesOrder,
  initializeForm,
  initializeSalesOrderForm,
  resetCurrentSalesOrder,
  setValue,
  requestSORefund,
  fetchAllShipping,
  setSaleOrderProductValues,
  printShippingList,
  printSalesOrder,
  printPickingList,
  printPackingList,
  printSalesOrderSI,
  finishUnmount,
  fetchSalesOrderDetailByNum,
  updateShippingWeight,
  updateEmployeeNote,
  fetchCarrierInfo,
  postCarrierInfo,
  getPaymentTerms,
  fetchFJAgents,
  fetchFJCarriers,
  fetchFBAAddressOptions,
  fetchCompany,
  fetchWarehousesByCompany,
  createSalesQuote,
  fetchBatchesByID,
  fetchSalesOrderProductByID,
  QBAuthStatusCheck,
  getQBAuth,
} from '../../actions/sales_actions';

const isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

const validate = (values) => {
  const errors = {};
  if (values.Quantity && !isNumeric(values.Quantity)) {
    errors.Quantity = 'Accept number only!';
  }
  if (values.Quantity && (values.Quantity < 0)) {
    errors.Quantity = 'Positive number only!';
  }
  if (values.UnitPrice && !isNumeric(values.UnitPrice) && values.UnitPrice !== '-') {
    errors.UnitPrice = 'Accept number only!';
  }
  // if (values.UnitPrice && (values.UnitPrice < 0)) {
  //   errors.UnitPrice = 'Positive number only!';
  // }
  if (!values.Deliver_Customer_id) {
    errors.Deliver_Customer_id = 'Required';
  }
  return errors;
};

let salesOrderForm = reduxForm({
  form: 'salesOrderForm',
  validate,
  enableReinitialize: true,
  touchOnChange: true,
  touchOnBlur: false,
})(SalesOrderForm);

salesOrderForm = connect(
  state => ({
    initialValues: state.salesOrders.currentSalesOrderDetail,
  })
)(salesOrderForm);

const selector = formValueSelector('salesOrderForm');

function mapStateToProps(state) {
  const available = selector(state, 'Available');
  const createTime = selector(state, 'CreateTime');
  const creditRadios = selector(state, 'creditRadios');
  const customerChosen = selector(state, 'Deliver_Customer_id');
  const Deliver_CustomerDetail_id = selector(state, 'Deliver_CustomerDetail_id');
  const description = selector(state, 'CustomerDescription');
  const discount = selector(state, 'Discount');
  
  const dispatchDate = selector(state, 'DispatchDate');
  const dispatchStartTime = selector(state, 'DispatchStartTime');
  const dispatchEndTime = selector(state, 'DispatchEndTime');
  
  const shipByDate = selector(state, 'ShipByDate');
  const employeeNote = selector(state, 'EmployeeNote');
  const routeNote = selector(state, 'RouteNote');
  const inPurchase = selector(state, 'InPurchase');
  const inventoryIdValue = selector(state, 'Inventory_id');
  const itemNotation = selector(state, 'itemNotation');

  const ReceivedQuantity = selector(state, 'ReceivedQuantity');
  const ShipmentID = selector(state, 'ShipmentID');
  const ServiceType = selector(state, 'ServiceType');
  const CustomerRef = selector(state, 'CustomerRef');
  const Unloader = selector(state, 'Unloader');
  const TruckVendor = selector(state, 'TruckVendor');

  const ISANum = selector(state, 'ISANum');
  const BillablePallets = selector(state, 'BillablePallets');
  const RealPallets = selector(state, 'RealPallets');
  const BoxPerPallet = selector(state, 'BoxPerPallet');
  const PalletQuantity = selector(state, 'PalletQuantity');
  const BoxQuantity = selector(state, 'BoxQuantity');
  const PieceQuantity = selector(state, 'PieceQuantity');
  const DispatchType = selector(state, 'DispatchType');
  const BoxVol = selector(state, 'BoxVol');
  const BoxLength = selector(state, 'BoxLength');
  const BoxWidth = selector(state, 'BoxWidth');
  const InnerLabelQty = selector(state, 'InnerLabelQty');
  const OuterLabelQty = selector(state, 'OuterLabelQty');
  const BoxHeight = selector(state, 'BoxHeight');
  const BoxWeight = selector(state, 'BoxWeight');
  const RepackedPalletQuantity = selector(state, 'RepackedPalletQuantity');
  const PalletLength = selector(state, 'PalletLength');
  const PalletWidth = selector(state, 'PalletWidth');
  const PalletHeight = selector(state, 'PalletHeight');
  const PalletVol = selector(state, 'PalletVol');
  const PalletWeight = selector(state, 'PalletWeight');

  const UnitQuantity = selector(state, 'UnitQuantity');
  const UnitLength = selector(state, 'UnitLength');
  const UnitWidth = selector(state, 'UnitWidth');
  const UnitHeight = selector(state, 'UnitHeight');
  const UnitVol = selector(state, 'UnitVol');

  const IsOversize = selector(state, 'IsOversize');
  const IsOverweight = selector(state, 'IsOverweight');
  const PortDray = selector(state, 'PortDray');
  const DrayageTrucker = selector(state, 'DrayageTrucker');
  const Location = selector(state, 'Location');
  const WarehouseLocation = selector(state, 'WarehouseLocation');
  const Zone = selector(state, 'Zone');
  const Section = selector(state, 'Section');
  const Bin = selector(state, 'Bin');


  const FBACode = selector(state, 'FBACode');
  const TotalShippingWeight = selector(state, 'TotalShippingWeight');
  const NMFCClass = selector(state, 'NMFCClass');


  const FBARoute = selector(state, 'FBARoute');
  const DimUnit = selector(state, 'DimUnit');

  // const VendorStyleNum = selector(state, 'VendorStyleNum');
  // const TJXStyleNum = selector(state, 'TJXStyleNum');
  // const LineDescription = selector(state, 'LineDescription');
  // const UPC = selector(state, 'UPC');
  // const Color = selector(state, 'Color');
  // const Size = selector(state, 'Size');
  // const TotalUnits = selector(state, 'TotalUnits');
  const StoreReady = selector(state, 'StoreReady');
  const PalletStackable = selector(state, 'PalletStackable');
  const Preticketed = selector(state, 'Preticketed');
  const CantonNum = selector(state, 'CantonNum');
  const OriginCountry = selector(state, 'OriginCountry');


  const WeightUnit = selector(state, 'WeightUnit');
  const TrailerNum = selector(state, 'TrailerNum');
  const POList = selector(state, 'POList');
  const POD = selector(state, 'POD');

  // const ContainerNum = selector(state, 'ContainerNum');
  const AvailableQuantity = selector(state, 'AvailableQuantity');
  const AvailableQuantityPallet = selector(state, 'AvailableQuantityPallet');
  const AvailableQuantityBox = selector(state, 'AvailableQuantityBox');
  const AvailableQuantityPiece = selector(state, 'AvailableQuantityPiece');

  const notation = selector(state, 'Notation');
  const note = selector(state, 'Note');
  const orderDate = selector(state, 'OrderDate');
  const preSale = selector(state, 'PreSale');
  const previousOrderFromDate = selector(state, 'PreviousOrderFromDate');
  const previousOrderToDate = selector(state, 'PreviousOrderToDate');
  const quantityValue = selector(state, 'Quantity');
  const receivingCustomer = selector(state, 'receivingCustomer');
  const refPurchasePrice = selector(state, 'RefPurchasePrice');
  const salePrice = selector(state, 'SalePrice');
  const sales = selector(state, 'Sales');
  const soNum = selector(state, 'SONum');
  const searchType = selector(state, 'searchType');
  const searchValue = selector(state, 'ProductInformation');
  const shipperChosen = selector(state, 'CustomerDetail_id');
  const subtotal = selector(state, 'Subtotal');
  const taxRate = selector(state, 'TaxRate');
  const unitPrice = selector(state, 'UnitPrice');
  const weight = selector(state, 'Weight');
  const savings = selector(state, 'Savings');
  const productCost = selector(state, 'ProductCost');
  const Sales_User_id = selector(state, 'Sales_User_id');
  const PaymentTerm_id = selector(state, 'PaymentTerm_id');
  const PackageSize_1 = selector(state, 'PackageSize_1');
  const jmlBox = selector(state, 'jmlBox');

  const Company_id = selector(state, 'Company_id');
  const Pickup_Warehouse_id = selector(state, 'Pickup_Warehouse_id');

  return {
    PackageSize_1,
    jmlBox,
    PaymentTerm_id,
    Sales_User_id,
    available,
    createTime,
    creditRadios,
    customerChosen,
    Deliver_CustomerDetail_id,
    description,
    discount,
    Company_id,
    Pickup_Warehouse_id,
    
    dispatchDate,
    dispatchStartTime,
    dispatchEndTime,
    
    shipByDate,
    employeeNote,
    routeNote,
    inPurchase,
    inventoryIdValue,
    itemNotation,

    ReceivedQuantity,
    ShipmentID,
    ServiceType,
    CustomerRef,
Unloader,
TruckVendor,
    ISANum,
    BillablePallets,
    RealPallets,
    BoxPerPallet,
    PalletQuantity,
    BoxQuantity,
    PieceQuantity,
    FBACode,
    DispatchType,
    BoxVol,
    BoxWidth,
    InnerLabelQty,
    OuterLabelQty,
    BoxHeight,
    BoxLength,
    BoxWeight,
    RepackedPalletQuantity,
    PalletLength,
    PalletWidth,
    PalletHeight,
    PalletVol,

    UnitQuantity,
   UnitLength,
   UnitWidth,
   UnitHeight,
   UnitVol,

    PalletWeight,
    IsOversize,
    IsOverweight,
    PortDray,
    DrayageTrucker,
    TotalShippingWeight,
    NMFCClass,
    FBARoute,
    DimUnit,


    // VendorStyleNum,
// TJXStyleNum,
// LineDescription,
// UPC,
// Color,
// Size,
// TotalUnits,
StoreReady,
PalletStackable,
Preticketed,
CantonNum,
OriginCountry,


    WeightUnit,
    TrailerNum,
    POList,
    POD,
    Location,
    WarehouseLocation,
    Zone,
    Section,
    Bin,
    // ContainerNum,
    AvailableQuantity,
    AvailableQuantityPallet,
    AvailableQuantityBox,
    AvailableQuantityPiece,

    notation,
    note,
    orderDate,
    preSale,
    previousOrderFromDate,
    previousOrderToDate,
    quantityValue,
    receivingCustomer,
    refPurchasePrice,
    salePrice,
    sales,
    soNum,
    searchType,
    searchValue,
    shipperChosen,
    subtotal,
    taxRate,
    unitPrice,
    weight,
    savings,
    productCost,
    
    users: state.settings.all,

    currentSalesOrder: state.salesOrders.currentSalesOrder,
    currentSalesOrderDetail: state.salesOrders.currentSalesOrderDetail,
    detailIsLoading: state.salesOrders.detailIsLoading,
    detailError: state.salesOrders.detailError,
    initialValues: state.salesOrders.currentSalesOrderDetail,

    customers: state.customers.all,
    customersIsLoading: state.customers.isLoading,
    customersError: state.customers.error,

    isCreating: state.salesOrders.isCreating,
    createError: state.salesOrders.createError,
    created: state.salesOrders.created,
    isEditing: state.salesOrders.isEditing,
    editError: state.salesOrders.editError,
    edited: state.salesOrders.edited,

    salesOrderEdited: state.salesOrders.salesOrderEdited,
    salesOrderIsEditing: state.salesOrders.salesOrderIsEditing,
    salesOrderEditError: state.salesOrders.salesOrderEditError,

    salesOrderCreated: state.salesOrders.salesOrderCreated,
    salesOrderIsCreating: state.salesOrders.salesOrderIsCreating,
    salesOrderCreateError: state.salesOrders.salesOrderCreateError,

    customerPrices: state.salesOrders.customerPrices,
    customerPricesIsLoading: state.salesOrders.customerPricesIsLoading,
    customerPricesError: state.salesOrders.customerPricesError,

    inventories: state.inventories.salesOrderInventory,
    inventoriesIsLoading: state.inventories.salesOrderInventoryIsLoading,
    inventoriesError: state.inventories.salesOrderInventoryError,

    // favorites: state.favorites.all,
    // favoritesIsLoading: state.favorites.isLoading,
    // favoritesError: state.favorites.error,
    // currentFavorites: state.favorites.currentFavorites,

    customersWithFavorites: state.customerFavorites.customersWithFavorites,

    previousSOs: state.previousOrders.SOs,
    previousOrders: state.previousOrders.all,
    previousOrdersIsLoading: state.previousOrders.isLoading,
    previousOrdersError: state.previousOrders.error,
    currentPreviousOrders: state.previousOrders.currentPreviousOrders,

    salesOrderDetailByNum: state.salesOrders.currentSalesOrderDetailByNum,
    detailByNumIsLoading: state.salesOrders.detailByNumIsLoading,
    detailByNumError: state.salesOrders.detailByNumError,

    promotions: state.promotions.all,
    promotionsIsLoading: state.promotions.isLoading,
    promotionsError: state.promotions.error,
    currentPromotions: state.promotions.currentPromotions,
    userPermissions: state.auth.userPermissions,

    taxRates: state.salesOrders.taxRates,
    taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
    taxRatesError: state.salesOrders.taxRatesError,

    paymentTerms: state.paymentTerms.all,
    paymentTermsIsLoading: state.paymentTerms.isLoading,
    paymentTermsError: state.paymentTerms.error,

    salesCustomerDetails: state.salesOrders.salesCustomerDetails,
    salesShippingCustomerDetails: state.salesOrders.salesShippingCustomerDetails,
    salesCustomerDetailsIsLoading: state.salesOrders.salesCustomerDetailsIsLoading,
    salesCustomerDetailsError: state.salesOrders.salesCustomerDetailsError,

    allShipping: state.salesOrders.allShipping,
    allShippingIsLoading: state.salesOrders.allShippingIsLoading,
    allShippingError: state.salesOrders.allShippingError,

    salesItemHistory: state.salesOrders.salesItemHistory,
    // salesItemHistoryIsLoading: state.salesOrders.salesItemHistoryIsLoading,
    // salesItemHistoryError: state.salesOrders.salesItemHistoryError,

    customerSalesHistory: state.salesOrders.customerSalesHistory,
    customerSalesHistoryIsLoading: state.salesOrders.customerSalesHistoryIsLoading,
    customerSalesHistoryError: state.salesOrders.customerSalesHistoryError,

    customerFrequent: state.salesOrders.customerFrequent,
    customerFrequentIsLoading: state.salesOrders.customerFrequentIsLoading,
    customerFrequentError: state.salesOrders.customerFrequentError,

    productInfo: state.products.productInfo,
    productInfoIsLoading: state.products.productInfoIsLoading,
    productInfoError: state.products.productInfoError,

    favoriteList: state.favorites.favoriteList,
    favoriteListIsLoading: state.favorites.favoriteListIsLoading,
    favoriteListError: state.favorites.favoriteListError,

    checkingPermission: state.settings.checkingPermission,
    checkPermissionSuccess: state.settings.checkPermissionSuccess,
    checkPermissionFailure: state.settings.checkPermissionFailure,

    salesOrderProduct: state.salesOrders.salesOrderProduct,
    salesOrderProductIsLoading: state.salesOrders.salesOrderProductIsLoading,
    salesOrderProductFailure: state.salesOrders.salesOrderProductFailure,

    requestingShippingList: state.salesOrders.requestingShippingList,
    shippingListPDF: state.salesOrders.shippingListPDF,

    requestingPickingList: state.salesOrders.requestingPickingList,
    pickingListPDF: state.salesOrders.pickingListPDF,

    requestingPackingList: state.salesOrders.requestingPackingList,
    packingListPDF: state.salesOrders.packingListPDF,

    requestingSalesOrderPDF: state.salesOrders.requestingSalesOrderPDF,
    salesOrderPDF: state.salesOrders.salesOrderPDF,

    requestingSalesOrderSIPDF: state.salesOrders.requestingSalesOrderSIPDF,
    salesOrderSIPDF: state.salesOrders.salesOrderSIPDF,
    
    requestingRefundPDF: state.salesOrders.requestingRefundPDF,
    refundPDF: state.salesOrders.refundPDF,

    prevEstDate: state.salesOrders.prevEstDate,
    prevEstDateIsNeeded: state.salesOrders.prevEstDate,
    
    batchesInfo: state.salesOrders.batchesInfo,
  };
}

export default connect(mapStateToProps, {
  checkPermission,
  clearConvertingToInvoice,
  clearInventories,
  clearSalesCustomerDetails,
  clearUpdateSalesInvoice,
  createSalesOrder,
  destroyEstDate,
  editSalesOrder,
  fetchActiveCustomers,
  fetchAllShipping,
  fetchBaseUsers,
  fetchCustomerSalesHistory,
  fetchCustomerFrequent,
  fetchInboundProducts,
  fetchCustomerPrices,
  fetchCustomers,
  fetchCustomersWithFavorites,
  fetchFavoriteList,
  fetchFavorites,
  fetchItemSalesHistory,
  fetchPaymentTerms,
  fetchPreviousOrders,
  fetchPreviousOrderById,
  fetchPreviousSalesOrderByIndexFromLast,
  fetchPreviousSalesOrderByCustomer,
  fetchPreviousOrdersFromALLSalesOrder,
  fetchPreviousOrderBySearch,
  fetchProductInfo,
  fetchProductInfo2,
  fetchPromotions,
  fetchSalesCustomerDetail,
  fetchSalesOrderDetail,
  fetchSalesOrderForm,
  fetchSalesOrderInventory,
  fetchTaxRates,
  finishUnmount,
  initializeForm,
  initializeSalesOrderForm,
  keepEstDate,
  printPackingList,
  printPickingList,
  printSalesOrder,
  printShippingList,
  requestSORefund,
  resetCurrentSalesOrder,
  resetFormInputs,
  selectSalesOrder,
  setCredit,
  setDefaultSearchType,
  setSaleOrderProductValues,
  setSaleRowValue,
  setSubtotal,
  setValue,
  fetchSalesOrderDetailByNum,
  fetchVendors,
  updateShippingWeight,
  updateEmployeeNote,
  fetchCarrierInfo,
  postCarrierInfo,
  getPaymentTerms,
  fetchFJAgents,
  fetchFJCarriers,
  fetchFBAAddressOptions,
  setDefaultOfForm,
  printSalesOrderSI,
  fetchCompany,
  fetchWarehousesByCompany,
  createSalesQuote,
  fetchBatchesByID,
  fetchSalesOrderProductByID,
  QBAuthStatusCheck,
  getQBAuth,
})(salesOrderForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/salesOrderForm.jsx